import React from 'react';
import classNames from 'classnames';
import SearchableSelect from 'molecules/SearchableSelect';
import CustomSingleOptionWithClear, { shiftColors, shiftIcons, customShiftOption } from 'helper/shift-timings/helper-function';

function ShiftSelect({
  value,
  onChange,
  shifts = [],
  size = 's',
  height = 24,
  placeholder = '',
  className = '',
  isDisabled = false,
  readOnly = false,
  ...rest
}) {
  const selectedShift = value;
  const shiftType = selectedShift?.shiftType;
  const shiftStyle = shiftType ? shiftColors[shiftType] : 'text-black';
  const icon = shiftIcons[shiftType] || '';
  const typeFirstLetter = shiftType?.charAt(0) || '';
  const time = selectedShift?.label || '';

  return (
    <div className={classNames('relative w-full shiftSelect', className)}>
      {selectedShift && (
        <div className="absolute inset-y-0 left-1 flex items-center gap-1 pointer-events-none">
          {icon && (
            <img
              src={icon}
              alt={`${shiftType} icon`}
              className={size === 's' ? 'w-2 h-2' : 'w-3 h-3'}
            />
          )}
          <div
            className={classNames(
              size === 's' ? 'text-[9px]' : 'text-xs',
              shiftStyle
            )}
          >
            <span className='font-semibold'>{typeFirstLetter} </span>{time}
          </div>
        </div>
      )}

      <SearchableSelect
        className={classNames(
          'calender-custom-select w-full',
          selectedShift && 'active-select',
          shiftStyle
        )}
        value={value}
        options={shifts}
        size={size}
        height={height}
        onChange={onChange}
        getOptionLabel={(option) => option.label}
        placeholder={placeholder}
        isDisabled={isDisabled}
        readOnly={readOnly}
        components={{ Option: customShiftOption, MenuList: CustomSingleOptionWithClear }}
        menuStyle={{ width: '195px' }}
        {...rest}
      />
    </div>
  );
}

export default ShiftSelect;
